// src/components/tour/worker/WorkerCalendarTourSteps.tsx
import { Step } from 'react-joyride';

const WorkerCalendarTourSteps: Step[] = [
  {
    target: '.tour-title',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Bienvenido a tu <strong>Calendario</strong>. Aquí puedes ver, gestionar
        y crear tus citas de forma visual, navegando entre días, semanas o el
        mes completo.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-filters-toggle',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Este panel de <strong>filtros</strong> se puede colapsar o expandir
        pulsando aquí, para ganar espacio cuando no lo necesitas.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-view-selector',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Usa este selector para <strong>cambiar la vista</strong> del
        calendario. Puedes ver tus citas por día, semana o mes, según
        prefieras.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-prev-today-next',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Usa estos botones para <strong>navegar entre fechas</strong>: ir al día
        anterior, volver a hoy o avanzar al siguiente periodo.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-title-display',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Esta área muestra el <strong>intervalo de tiempo actual</strong>, como
        "Semana del 10 al 16 de junio".
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-event-grid',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí verás tus <strong>citas y eventos programados</strong>. Cada
        bloque representa una cita según su horario. Haz clic sobre cualquier
        cita para ver sus detalles completos, o arrastra sobre un hueco libre
        para <strong>crear una nueva</strong>.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: 'body',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Al abrir una cita podrás <strong>gestionar acciones</strong> como
        marcarla como completada, reprogramarla, cancelarla o anularla con un
        motivo — todo desde la misma ventana.
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
  },
];

export default WorkerCalendarTourSteps;